import React, { ReactElement } from 'react';

import { DonutChart } from './donut';
import { MinimalDonutChartProps } from '../types';

export const MinimalDonutChart = <Datum = unknown,>({ ...rest }: MinimalDonutChartProps<Datum>): ReactElement => {
	return <DonutChart enableMouseInteraction={false} showBevel={false} showCenteredLabel={false} {...rest} />;
};
